import {Component} from '@angular/core';

@Component({
  selector: 'app-floating-button',
  templateUrl: './floating-button.component.html'
})
export class FloatingButtonComponent {
}
